import React from "react";
import {useForm} from "react-hook-form";
import {LoginButton, ModalContainer} from "../../styles/Styles";
import axios from "axios";
import Cookies from "js-cookie";

type Inputs = {
    file: any;
}

const UploadTourListForm = ({ bookingLabel = "" }) => {
    const url = `${process.env.REACT_APP_BACKEND_URL}/booking/uploadBookingDoc` || "";


    const {
        register,
        handleSubmit,
    } = useForm<Inputs>();

    const onSubmit = async(data: any) => {
        const accessToken = Cookies.get("accessToken");
        const formData = new FormData();
        formData.append("file", data.file[0]);
        formData.append("bookingSystem", bookingLabel);
        axios.post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${accessToken}`,
            }
        }).then((response) => {
            console.log(response);
        }).catch((e) => {
            console.log(e);
        })
    }

    return (<ModalContainer>
        <form onSubmit={handleSubmit(onSubmit)} className="form-v">
            <input type="file" {...register("file", {required: "Select a file" })} />

            <LoginButton type="submit">Upload file for {bookingLabel}</LoginButton>
        </form>
    </ModalContainer>);

}

export default UploadTourListForm;
